import React, { useMemo } from 'react'
import { ATLSpacing, SpacingSizesEnum } from '@appsimples/atlantica-react-native'
import { EventTypes, PresenceStatus } from './constants'
import { GenericAppointment } from './GenericAppointment'
import { icons } from '../../constants/searchAssets'
import { GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations } from '../../services/types/GetUserKeysDeliveryEventInvitations'
import { AppointmentDataFactory } from './classes/AppointmentDataFactory'
import { AppointmentDisplayData } from './classes/AppointmentDataGetter'
import { GetAvailableVisitationRaffles_listUserVisitEvents } from '../../services/types/getAvailableVisitationRaffles'

interface AppointmentsListProps {
  appointments:
    | GetAvailableVisitationRaffles_listUserVisitEvents[]
    | GetUserKeysDeliveryEventInvitations_listUserKeysDeliveryEventInvitations[]
  onPressCancelKeysDelivery: (invitationId: string, eventId: string, constructionName: string) => void
  onPressConfirmKeysDelivery: (invitationId: string, eventId: string) => void
  onPressCancelVisitation: (id: string) => void
  onPressConfirmVisitation: (id?: string) => void
  isLoading?: boolean
}

export const AppointmentsList: React.FC<AppointmentsListProps> = ({
  appointments,
  onPressCancelKeysDelivery,
  onPressCancelVisitation,
  onPressConfirmKeysDelivery,
  onPressConfirmVisitation,
  isLoading,
}) => {
  let appointmentData: AppointmentDisplayData

  const appointmentDataFactory = new AppointmentDataFactory({
    onPressCancelVisitation,
    onPressConfirmVisitation,
    onPressCancelKeysDelivery,
    onPressConfirmKeysDelivery,
  })

  const showAppointment = appointment =>
    appointment?.type === EventTypes.VISIT_TO_CONSTRUCTION ||
    (appointment?.keysDeliveryEvent?.isCanceled === false && appointment?.keysDeliveryEvent?.isPublished === true)

  return (
    <>
      {// @ts-ignore
      //This ts-ignore is being used due to the type of appointments, which is a union of two different types, that causes a TS complaint though it works
      appointments?.map(appointment => {
        const dataGetter = appointmentDataFactory.getDataGetter(appointment)
        appointmentData = dataGetter.getAppointmentDisplayData(appointment)

        const {
          constructionName,
          eventDate,
          eventTime,
          eventAddress,
          bottomMessage,
          confirmAction,
          cancelAction,
          presenceStatus,
          subtitle,
          title,
        } = appointmentData

        return (
          showAppointment(appointment) && (
            <>
              <GenericAppointment
                isLoading={isLoading}
                key={appointment?.id}
                title={title}
                subtitle={subtitle}
                constructionIcon={icons.home} //TODO: integrate after back add icon
                constructionName={constructionName}
                date={eventDate}
                time={eventTime}
                address={eventAddress}
                bottomMessage={bottomMessage}
                confirmAction={confirmAction}
                cancelAction={cancelAction}
                presenceStatus={presenceStatus}
              />
              <ATLSpacing type={SpacingSizesEnum.marginal} />
            </>
          )
        )
      })}
    </>
  )
}
